import { useContext, useEffect, useRef, useState } from "react";
import ActionItems from "../components/commonItems/actionItems.js";
import Viewer3d from "../components/commonItems/viewer3d";
import CurrentContext from "../utils/CurrentContext.js";

import styles from "../assets/sass/viewer3d.module.sass";
import { VaultModels as SafeModels } from "../components/models/models";
import { Colors, VaultOptions as SafeOptions } from "../utils/safeOptions";
import classNames from "classnames";
import OpenCloseToggle from "../components/commonItems/openCloseToggle.js";

export default function VaultDoor() {
  const [currentVariant, setCurrentVariant] = useState({
    hardware: "blackchromehardware",
    outer: "texturedblack",
    interior: "grayfabric",
  });
  const [lockType, setLockType] = useState("mechanicallock");
  const {
    current,
    setCurrent,
    colorVariant,
    setColorVariant,
    lockVariant,
    setLockVariant,
    isEditEnabled,
    SetHingeType,
  } = useContext(CurrentContext);

  const viewerWrapperRef = useRef(); //used for pdf

  const handleModel = (modelname) => {
    setCurrent(modelname);
    setLockType("mechanicallock");
    setCurrentVariant({
      hardware: "blackchromehardware",
      outer: "texturedblack",
      interior: "none",
      Hinge: "left",
      Swing: "out",
    });
  };

  useEffect(() => {
    setCurrent("vaultdoorblockade");
    setColorVariant({
      hardware: "blackchromehardware",
      outer: "texturedblack",
      interior: "none",
      Hinge: "left",
      Swing: "out",
    });
    setLockVariant("securamtoplit");
  }, []);

  // this useEffect is used for just listening iframe message
  // useEffect(() => {
  //   setLockType(lockVariant);
  //   setCurrentVariant(colorVariant);
  // }, [colorVariant, lockVariant]);

  useEffect(() => {
    lockVariant === null ? setLockType("securamtoplit") : setLockType(lockVariant);
    if(colorVariant === null){
      setCurrentVariant({
        hardware: "blackchromehardware",
        outer: current === "vaultdoorblockade" ? "texturedblack" : "bronzegloss",
        interior: "none",
        Hinge: "left",
        Swing: "out",
      });
    }else{
      setCurrentVariant(colorVariant);
    }
  }, [colorVariant, lockVariant]);

  return (
    <div className={styles.viewer_3d} ref={viewerWrapperRef}>
      {isEditEnabled && (
        <div className={styles.debugOptionPanel}>
          <h2 className={styles.variantHeading}>Sizes</h2>
          {SafeOptions.sizes.map((size) => (
            <button
              key={size}
              className={classNames(
                current === size ? styles.activebutton : ""
              )}
              onClick={() => handleModel(size)}
            >
              {size}
            </button>
          ))}

          <h2 className={styles.variantHeading}>Hinge</h2>
          {SafeOptions.hinge.map((hinge) => (
            <button
              key={hinge}
              className={classNames(
                currentVariant.Hinge === hinge ? styles.activebutton : ""
              )}
              onClick={() =>
                setCurrentVariant((prevState) => ({
                  ...prevState,
                  Hinge: hinge,
                }))
              }
            >
              {hinge}
            </button>
          ))}

          {current !== "vaultdoorblockade" ? (
            <>
              <h2 className={styles.variantHeading}>Swing</h2>
              {SafeOptions.swing.map((swing) => (
                <button
                  key={swing}
                  className={classNames(
                    currentVariant.Swing === swing ? styles.activebutton : ""
                  )}
                  onClick={() =>
                    setCurrentVariant((prevState) => ({
                      ...prevState,
                      Swing: swing,
                    }))
                  }
                >
                  {swing}
                </button>
              ))}

              <h2 className={styles.variantHeading}>Color</h2>
              {/* {SafeOptions.colors.map((option) => ( */}
              {Colors.map((option) => (
                <button
                  key={option.hardware + option.outer + option.interior}
                  className={classNames(
                    currentVariant.hardware === option.hardware &&
                      currentVariant.outer === option.outer &&
                      currentVariant.interior === option.interior
                      ? styles.activebutton
                      : ""
                  )}
                  onClick={() =>
                    setCurrentVariant((prevState) => ({
                      ...prevState,
                      hardware: option.hardware,
                      outer: option.outer,
                      interior: option.interior,
                    }))
                  }
                >
                  <p>{option.outer}</p>
                  <p>{option.interior}</p>
                  <p>{option.hardware}</p>
                </button>
              ))}
            </>
          ) : null}

          <h2 className={styles.variantHeading}>Lock Type</h2>
          {SafeOptions.locks.map((lock) => {
            if (
              (current === "vaultdoorblockade" && lock !== "mechanicallock" && lock !== "securamprologic") ||
              (current !== "vaultdoorblockade" && lock !== "securamtoplit")
            ) {
              return (
                <button
                  key={lock}
                  className={classNames(
                    lockType === lock ? styles.activebutton : ""
                  )}
                  onClick={() => setLockType(lock)}
                >
                  {lock}
                </button>
              );
            } else {
              return null;
            }
          })}
          <br />
          <br />
          <br />
        </div>
      )}
      <OpenCloseToggle />
      <div className={styles.viewerWrapper}>
        <Viewer3d
          models={SafeModels}
          baseModel={SafeOptions.sizes[0]}
          currentVariant={currentVariant}
          lockType={lockType}
        />
      </div>
      <ActionItems
        current={current}
        currentVariant={currentVariant}
        viewerWrapperRef={viewerWrapperRef}
      />
    </div>
  );
}
